(function () {
  if (window.CuftBannerStat) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function run(el) {
    var target = Number(el.getAttribute('data-stat-target')) || 0;
    var duration = (Number(el.getAttribute('data-stat-duration')) || 3) * 1000;
    var out = el.querySelector('[data-stat-value]');
    if (!out || !target) return;
    var format = function (n) { return Math.round(n).toLocaleString(); };
    if (reducedMotion.matches) {
      out.textContent = format(target);
      return;
    }
    var start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      out.textContent = format(target * eased);
      if (t < 1) requestAnimationFrame(frame);
    }
    out.textContent = '0';
    requestAnimationFrame(frame);
  }

  function init(scope) {
    var stats = (scope || document).querySelectorAll('[data-banner-stat]');
    if (!stats.length) return;
    if (!('IntersectionObserver' in window)) {
      stats.forEach(run);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        run(entry.target);
      });
    }, { threshold: 0.4 });
    stats.forEach(function (el) {
      if (el._cuftStat) return;
      el._cuftStat = true;
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.CuftBannerStat = { init: init };
})();
